import React from 'react'
import withNavigation from '../apps/common/navigation/hoc/withNavigation'
import E403Layout from './E403Layout'

const E403Container = ({ location }) => <E403Layout reason={location.state.reason} />

export default withNavigation(E403Container)